import React from 'react';
import AdminSpecialPaymentFormContainer from '../../../../Containers/AdminContainer/AdminSpecialPaymentContainer/AdminSpecialPaymentFormContainer';

const AdminSpecialPaymentFormScreen = () => {
  return <AdminSpecialPaymentFormContainer />;
};

export default AdminSpecialPaymentFormScreen;
